// @flow
import React, { Fragment } from 'react';

import { INLINE_3 } from 'Components/frameworks/card/Card.constants';
import ratioUtils from 'Components/utils/ratios/ratios.utils';

import { Card } from 'Components/frameworks/card/Card.jsx';

type ProductCateringProps = {
  intros?: Array<{
    description?: string,
    title?: string,
  }>,
  list?: Array<{
    description?: string,
    image?: string,
    name?: string,
  }>,
  seeLessLabel?: string,
  seeMoreLabel?: string,
};

export function ProductCatering({
  intros = [],
  list = [],
  seeLessLabel,
  seeMoreLabel,
}: ProductCateringProps) {
  const hasIntros = !!intros.length;
  const hasList = !!list.length;

  if (!hasIntros && !hasList) return null;

  return (
    <div className="pb-8">
      {hasIntros && (
        <div className="flex">
          {intros.map(({ description, title = '' }) => (
            <Card
              className="w-full md:w-1/2"
              key={title}
              heading={{ title }}
              text={{ text: description }}
            />
          ))}
        </div>
      )}
      {hasIntros &&
        hasList && (
          <hr className="block border-0 border-solid border-gray-light border-t-1 h-px my-4 mx-0 p-0" />
        )}
      {hasList &&
        list.map(({ description, image = '', name = '' }, index) => {
          return (
            (description || name) && (
              <Fragment key={name}>
                {index > 0 && (
                  <hr className="block border-0 border-solid border-gray-light border-t-1 h-px my-4 mx-0 p-0" />
                )}
                <Card
                  heading={{ title: name }}
                  layout={INLINE_3}
                  media={{ url: image, ratioKey: ratioUtils.M }}
                  seeLessLabel={seeLessLabel}
                  seeMoreLabel={seeMoreLabel}
                  text={{ text: description }}
                />
              </Fragment>
            )
          );
        })}
    </div>
  );
}
